import promoRestService from '../../services/PromoRestService';
import {
  setAnalyticsPages,
  setIsRefreshAnalyticsPages,
} from '../../slices/analytics/reducer';
export const createOrUpdateAnalytics = async (data) => {
  try {
    const result = await promoRestService?.post(
      'api/v1/analytics/create',
      data
    );

    return result?.data;
  } catch (e) {
    console.log(e);
  }
};

export const createOrUpdateAnalyticsPage = async (data, dispatch) => {
  try {
    const res = await promoRestService?.post(
      'api/v1/analytics/createOrUpdateAnalyticsPage',
      data
    );

    if (res?.data?._id) {
      dispatch(setIsRefreshAnalyticsPages(true));
    }
    return res?.data;
  } catch (e) {
    console.log(e);
  }
};

export const getAnalyticsPages = async (data, dispatch) => {
  try {
    const res = await promoRestService?.post('api/v1/analytics/getPages', data);

    if (res?.data) {
      dispatch(setAnalyticsPages(res?.data));
    }
    return res?.data;
  } catch (e) {
    console.log(e);
  }
};

export const createOrUpdateAnalyticsChart = async (data, dispatch) => {
  try {
    const res = await promoRestService?.post(
      'api/v1/analytics/createOrUpdateAnalyticsChart',
      data
    );

    if (res?.data?._id) {
      dispatch(setIsRefreshAnalyticsPages(true));
    }
    return res?.data;
  } catch (e) {
    console.log(e);
  }
};

export const getAnalyticsDetails = async (data) => {
  try {
    const res = await promoRestService?.post(
      'api/v1/analytics/getAnalyticsDetails',
      data
    );

    return res?.data;
  } catch (e) {
    console.log(e);
  }
};
